import { useMutation } from "react-query";
import { addOffice } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

const useAddOfficeSettings = () => {
  return useMutation(addOffice);
};
export default useAddOfficeSettings;
